var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6644_36961)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94888 5.93994L4.37988 10.4849L11.9909 18.0599L19.6019 10.4879L15.0329 5.93994H8.94888Z",
    fill: "#2DE370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73613 8.89199C10.5331 7.09199 13.4491 7.09199 15.2461 8.89199L16.8001 10.446L15.2461 12C13.4491 13.8 10.5331 13.8 8.73613 12L7.18213 10.446L8.73613 8.89199Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9909 12.3511C10.9409 12.3511 10.0889 11.5201 10.0889 10.4971C10.0889 9.47407 10.9409 8.64307 11.9909 8.64307C13.0409 8.64307 13.8929 9.47407 13.8929 10.4971C13.8929 11.5201 13.0439 12.3511 11.9909 12.3511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 11.247C11.5499 11.247 11.1899 10.887 11.1899 10.446C11.1899 10.002 11.5499 9.64502 11.9909 9.64502C12.4319 9.64502 12.7919 10.005 12.7919 10.446C12.7919 10.89 12.4349 11.247 11.9909 11.247Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6644_36961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooks);
export default __webpack_public_path__ + "static/media/looks.f6990cfe369a6f72f0b49c5c9df9b3a5.svg";
export { ForwardRef as ReactComponent };